import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import './Reader.css';

function Reader({ albums })
{
   const { slug } = useParams();
   const navigate = useNavigate();
   const album = albums.find(a => a.dossier === slug);
   const [page, setPage] = useState(1);
   const [imageError, setImageError] = useState(false);
   const pageNumber = String(page).padStart(3, '0');
   const imagePath =`${process.env.REACT_APP_API_URL}/images/${album.dossier}/page-${pageNumber}.webp`;
   // navigation pages btn click
   const nextPage = () =>
   {
      if (page < album.nbPages)
         setPage(page + 1);
   };
   const previousPage = () =>
   {
      if (page > 1)
         setPage(page - 1);
   };
   useEffect(() =>
   {
      setImageError(false); // Réinitialiser l'état d'erreur lors du changement de page
   }, [page]);

   // navigation pages clavier
   useEffect(() =>
   {
      const handleKeyPress = (event) =>
      {
         if (event.key === 'ArrowRight')
            nextPage();
         else if (event.key === 'ArrowLeft')
            previousPage();
      };

      window.addEventListener('keydown', handleKeyPress);

      return () =>
      {
         window.removeEventListener('keydown', handleKeyPress);
      };

   }, [page]); // Déclenchement au changement de la variable entre crochets

   if (!album)
   {
      navigate('/');
      return null;
   }

   return (
      <div className="reader">

         <button className="back-button" onClick={ () => navigate('/') }>
            ← Retour à la galerie
         </button>

         <h2>{ album.titre }</h2>

         <div className="navigation">
            <button
               onClick={ previousPage }
               disabled={ page === 1 }>
               ← Précédente
            </button>
            <span>Page { page } / { album.nbPages }</span>
            <button
               onClick={ nextPage }
               disabled={ page === album.nbPages }>
               Suivante →
            </button>
         </div>

         <div className='comic-page'>
            { imageError ? 
            ( <div className="error-message">Erreur de chargement de l'image.</div> ) : 
            (
               <img
                  src={ imagePath }
                  alt={ `Page ${page}` }
                  onClick={ nextPage }
                  onError={()=> setImageError(true)}
               />
            )}
         </div>

      </div>
   )
}

export default Reader;